import * as _ from 'lodash';
import { Organization } from '../objects/Organization';

angular.module("tromanWeb").factory('OrganizationState', ['$q', 'ObjectCache', 'tromanServer', 'dialogService', function ($q, ObjectCache, tromanServer, dialogService) {

    function OrganizationState() {
    }

    OrganizationState.create = function (orgId) {
        return getOrganization(orgId)
            .then(loadRelated)
            .then(loaded)
            .catch(err => {
                dialogService.error(err);
                return $q.reject(err);
            });
    };

    function getOrganization(orgId) {
        if (orgId) {
            return tromanServer.Organizations.get(orgId);
        }
        return $q.when(new Organization());
    }

    function loadRelated(organization) {
        return $q.all({
            organization: $q.when(organization),
            organizationTypes: ObjectCache.getOrganizationTypes(organization.OrganizationType),
            wageGroups: ObjectCache.getWageGroups(organization.WageGroup),
            wageCalculations: ObjectCache.getWageCalculations(organization.WageCalculation),
            users: ObjectCache.getUsers(organization.ApprovedUserIds),
            systemSettings: tromanServer.System.getSettings(),
            persons: ObjectCache.getPersons(_.reject([organization.PrimaryCertifier, organization.SecondaryCertifier], _.isNil)),
        });
    }

    function loaded(data) {
        var ret = new OrganizationState();
        angular.extend(ret, data);
        if (!ret.organization.Id) {
            ret.organization.EnableTimereport = ret.systemSettings.EnableTimereport;
            ret.organization.AllowPolitikerRegistration = true;
        }
        return ret;
    }

    return OrganizationState;
}]);
